import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { Grid, Typography, Button, CircularProgress } from '@mui/material';
import MyDate1 from 'core/components/MyDate1';
import dayjs from 'dayjs';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { updateDesignStatusAPI } from 'api/OmsOrdermgmtWebServices';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';



import { setProductassetDashboardProductassetList, setProductassetList, updateProductObj } from 'store/slice/PharmaSlice';
import { getProductassetInfoByProductidAPI } from 'components/productasset/ProductassetAPI';
import ProductassetDashboard from 'components/productasset/ProductassetDashboard';
export default function DesignPrintingActionImpl() {
    const dispatch = useDispatch();
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const [localAPIinProgress, setLocalAPIinProgress] = useState(false);

    const [designOrderDate, setDesignOrderDate] = useState(null);
    const [designReceivedDate, setDesignReceivedDate] = useState(null);
    const [saveEnabled, setSaveEnabled] = useState(false);
    const [checked, setChecked] = useState(false);

    const getProductAssetListSuccessCallBack = (paList) => {
        dispatch(setProductassetList(paList))
    }
    const handleSaveButtonVisibility = () => {

        setDesignOrderDate(productObj.designorderedon)
        setDesignReceivedDate(productObj.designreceivedon)

        if (dateChanged(productObj.designorderedon, designOrderDate) || dateChanged(productObj.designreceivedon, designReceivedDate)) setSaveEnabled(true);
        else setSaveEnabled(false);

    }
    useEffect(() => {
        handleSaveButtonVisibility();
    }, [productObj]);


    useEffect(() => {
        getProductassetInfoByProductidAPI(productObj.id, () => { }, getProductAssetListSuccessCallBack);
        setDesignOrderDate(productObj.designorderedon);
        setDesignReceivedDate(productObj.designreceivedon);

    }, []);
    useEffect(() => {

        if (dateChanged(productObj.designorderedon, designOrderDate) || dateChanged(productObj.designreceivedon, designReceivedDate)) setSaveEnabled(true);
        else setSaveEnabled(false);

    }, [designOrderDate, designReceivedDate])

    const dateChanged = (date1, date2) => {
        if (date1 === null && date2 === null) return false;

        const dayjsDate1 = dayjs(date1);
        const dayjsDate2 = dayjs(date2);
        return !dayjsDate1.isSame(dayjsDate2)
    }

    const updateDesignstatusFailureCallback = (msg) => {
        setLocalAPIinProgress(false);
        alert(msg);
    }
    const updateDesignstatusSuccessCallback = (responseObj) => {
        setLocalAPIinProgress(false);

        dispatch(updateProductObj(responseObj.productInfo));
    }
    const updateDesignDate = () => {
        setLocalAPIinProgress(true);
        let payload = {
            productId: productObj.id,
        }

        if (dateChanged(productObj.designorderon, designOrderDate)) {
            payload = {
                ...payload,
                designOrderedDate: designOrderDate,
            }
        }
        if (dateChanged(productObj.designreceivedon, designReceivedDate)) {
            payload = {
                ...payload,
                designReceivedDate: designReceivedDate,
            }
        }
        updateDesignStatusAPI(payload, updateDesignstatusSuccessCallback, updateDesignstatusFailureCallback)
    }
    const handleChange = (event) => {
        setChecked(event.target.checked); // Update the state with the checkbox value
    };
    const updateDesignstatus = () => {
        setLocalAPIinProgress(true);
        if (checked) {
            let payload = {
                productId: productObj.id,
                designStatus: "DESIGN READY"
            }
            updateDesignStatusAPI(payload, updateDesignstatusSuccessCallback, updateDesignstatusFailureCallback)
        }

    }

    return (
        <Grid container direction="row" sx={{ width: '100%', justifyContent: "space-between", alignItems: 'flex-start' }}>
            <Grid lg={9} item>
                <ProductassetDashboard />
            </Grid>
            <Grid lg={3} item sx={{ paddingRight: 2, paddingTop: 5 }}>
                {
                    productObj.designstatus === 'DESIGN READY' ? <>
                        <Grid container sx={{ alignItems: "center", justifyContent: 'center', height: '50vh' }}>
                            <Typography variant="h4" color='primary'><i>This product is already marked as 'DESIGN READY'</i></Typography>
                        </Grid>

                    </> :
                        <Grid container direction="column" sx={{ width: '100%', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                            <Grid item sx={{ width: '100%', backgroundColor: 'white', padding: 1, borderRadius: 5 }}>
                                <Grid item>
                                    <Typography sx={{ padding: .5 }} color="primary">Ordered all Designs, On</Typography>
                                    <MyDate1 label="" defaultValue={designOrderDate} fieldName="designOrderDate" errStr="Wrong date" setDate={setDesignOrderDate} />
                                </Grid>
                                <Grid>&nbsp;</Grid>
                                <Grid item>
                                    <Typography sx={{ padding: .5 }} color="primary"  >Received all Designs, On</Typography>
                                    <MyDate1 label="" defaultValue={designReceivedDate} fieldName="designReceiveDate" errStr="Wrong date" setDate={setDesignReceivedDate} />
                                </Grid>
                                <Grid>&nbsp;</Grid>
                                <Grid sx={{ textAlign: 'right', justifyContent: 'right' }}>
                                    {localAPIinProgress && !checked ? <CircularProgress /> :
                                        <Button variant="outlined" disabled={!saveEnabled} onClick={() => updateDesignDate()}>Save</Button>
                                    }
                                </Grid>
                            </Grid>
                            <Grid>&nbsp;</Grid>

                            <Grid item sx={{ width: '100%', backgroundColor: 'white', padding: 1, borderRadius: 5 }}>
                                <Typography sx={{ padding: .5 }} color="primary"  >Is Design ready for this Product?</Typography>
                                <Grid container sx={{ justifyContent: 'space-between' }}>
                                    <Grid item>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={checked}
                                                    onChange={handleChange}
                                                    color="primary"
                                                    label="Yes"
                                                    disabled={productObj.rmstatus === 'RM READY'}
                                                />}
                                            label="Yes, It is ready"
                                        />
                                    </Grid>
                                    <Grid item>
                                        {localAPIinProgress && checked ? <CircularProgress /> :
                                            <Button variant="outlined" disabled={!checked} onClick={() => updateDesignstatus()}>Save</Button>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                }

            </Grid>
        </Grid>

    )

}